import { hashHistory } from 'react-router'

const roles = ['ADMIN', 'GTPB']
export const authorization = {
  'home': { [roles[0]]: true, [roles[1]]: true },
  'intro': { [roles[0]]: true, [roles[1]]: true },
  'browse': { [roles[0]]: true, [roles[1]]: true }
}

export const checkAuth = (role, page, doNotRedirect) => {
  if (role) {
    role = role.toUpperCase()
  }
  page = page && page.replace('/', '').toLowerCase()
  if (!role || !page) {
    !doNotRedirect && hashHistory.replace('/')
    return false
  }
  if (!authorization[page] || !authorization[page][role]) {
    !doNotRedirect && hashHistory.replace('/')
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/authorization.js